import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getTeammates(onSuccessEvent, onErrorEvent) {
  const response = await sendRequest()
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest() {
  const url = `${urls.getTeammates}`

  const headers = {
    Authorization: 'Zmz$muQCQJ6rw1BLQQV2WtT#nP80fzlZef7pXAD69P!C',
  }
  const response = await Network.sendGetRequestWithHeader(url, headers)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response.response.statusCode == 200
  ) {
    console.log(response.response)
    const rawData = response.response.users
    const appData = Formatter.parseTeammates(rawData)

    return {
      success: true,
      data: appData,
    }
  }
  if (
    response &&
    response.status.code === 404 &&
    response.response.statusCode == 404
  ) {
    const appData = Formatter.parseTeammates([])

    return {
      success: true,
      data: appData,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getTeammates }
